import React from 'react';
import styled from 'styled-components';
import { Form as BaseForm, withFormProps } from '../common/Form'
import { Input } from 'components/common/FormItems';


const StyledInput = styled(Input)`
  padding-right: 1.4rem;
`;
class Form extends BaseForm {

  educationFormSchema = {
    further_training: this.required,
  }

  renderUpperInputs = (state) => {
    return (
      <StyledInput
        onChange={this.onChange}
        value={state.further_training}
        name="further_training"
        label="Description"
        placeholder="Description"
        showRequiredAsterisk
      />
    )
  }
}

export default withFormProps(Form)
